import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {Config} from './../config/config.service';
import {first} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {PoolsMenuScope} from '../../NGRX/pool/pool.models';
import {selectPoolExtraModel} from '../../NGRX/pool/pool.selectors';
import {AppState} from '../../NGRX/core.state';
import {Store} from '@ngrx/store';

@Injectable()
export class HomepageRouteGuard {
    private poolExtraModel$: Observable<PoolsMenuScope.PoolsExtraModel> | undefined;
    private micrositeType: string;

    constructor(
        private _config: Config,
        private _router: Router,
        private store: Store<AppState>
    ) {
      this.micrositeType = this._config.CONFIG.micrositeType;
    }

    canActivate(): boolean {
        const isHomepageAllowed = true;
        this.poolExtraModel$ = this.store.select(selectPoolExtraModel);
        this.poolExtraModel$.pipe(first()).subscribe(poolExtraModel => {
            poolExtraModel && this.handlePoolExtraModel(poolExtraModel);
        });
        return this.isHomepageEnabled(isHomepageAllowed);
    }

    handlePoolExtraModel(poolExtraModel: PoolsMenuScope.PoolsExtraModel): void {
      // don't know why the fk we were checking for all only since all microsites could have a homepage
      this.isHomepageEnabled(poolExtraModel.poolCounts[this.micrositeType] !== 0);
    }

    isHomepageEnabled(isHomepageAllowed: boolean): boolean {
        if (isHomepageAllowed && this._config.CONFIG.haveHomepage) {
            return true;
        }
        this._router.navigate(['/pools']);
        return false;
    }
}
